var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaysafe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iv68db2gva)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.996.002C19.25.002 0 19.252 0 42.998c0 23.747 19.25 42.997 42.996 42.997 23.747 0 42.997-19.25 42.997-42.997 0-23.746-19.25-42.996-42.997-42.996zm0 65.107c-12.21 0-22.109-9.898-22.109-22.11 0-12.21 9.897-22.11 22.11-22.11 12.212 0 22.108 9.898 22.108 22.11 0 12.21-9.898 22.11-22.109 22.11z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.996 10.135c-18.15 0-32.863 14.713-32.863 32.863 0 18.152 14.713 32.864 32.863 32.864S75.86 61.15 75.86 42.998c0-18.15-14.714-32.863-32.864-32.863zm0 54.974c-12.21 0-22.109-9.898-22.109-22.11 0-12.21 9.897-22.11 22.11-22.11 12.212 0 22.108 9.899 22.108 22.11 0 12.21-9.898 22.11-22.109 22.11z",
    fill: "#CDD6E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.154 13.223 3.35 10.312a22.007 22.007 0 0 1 10.49-2.648c3.796 0 7.368.96 10.49 2.648 1.117-3.438 2.231-6.874 3.351-10.312-4.214-1.963-8.891-3.09-13.843-3.09s-9.626 1.127-13.838 3.09z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.987 3.497c-1.04 3.245-2.096 6.486-3.153 9.73-4.212-1.972-8.888-3.099-13.833-3.099a32.542 32.542 0 0 0-13.848 3.1c-1.04-3.245-2.096-6.486-3.153-9.71A42.662 42.662 0 0 1 43.002.005c6.037 0 11.79 1.234 16.985 3.491z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.839 72.77c-1.117-3.437-2.236-6.873-3.352-10.311a22.008 22.008 0 0 1-10.49 2.648c-3.796 0-7.368-.96-10.489-2.648-1.116 3.438-2.232 6.874-3.352 10.312 4.214 1.963 8.892 3.09 13.843 3.09 4.952 0 9.626-1.127 13.84-3.09z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.987 82.503C54.792 84.76 49.041 86 43.004 86a42.695 42.695 0 0 1-17.002-3.514c1.057-3.242 2.114-6.483 3.153-9.71 4.212 1.953 8.888 3.084 13.848 3.084 4.945 0 9.62-1.131 13.833-3.084 1.057 3.245 2.112 6.486 3.151 9.728z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m72.77 29.156-10.311 3.35a22.04 22.04 0 0 1 2.648 10.492c0 3.796-.962 7.368-2.648 10.489 3.438 1.116 6.874 2.232 10.312 3.35 1.962-4.212 3.088-8.89 3.088-13.841 0-4.95-1.126-9.626-3.088-13.84z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 43.001c0 6.038-1.234 11.789-3.493 16.984-3.243-1.04-6.485-2.096-9.728-3.153 1.953-4.212 3.082-8.886 3.082-13.832 0-4.963-1.129-9.639-3.082-13.847 3.225-1.04 6.468-2.096 9.71-3.153a42.706 42.706 0 0 1 3.512 17.001z",
    fill: "#FF7058"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.221 56.839c3.438-1.116 6.874-2.234 10.314-3.35a22.02 22.02 0 0 1-2.648-10.491c0-3.795.96-7.367 2.648-10.49-3.44-1.116-6.876-2.232-10.314-3.35-1.961 4.212-3.088 8.89-3.088 13.841 0 4.95 1.127 9.626 3.088 13.84z",
    fill: "#F1543F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.13 43c0 4.946 1.128 9.62 3.097 13.832-3.242 1.057-6.485 2.114-9.728 3.153C1.24 54.79.006 49.04.006 43.002a42.691 42.691 0 0 1 3.511-17c3.243 1.057 6.468 2.114 9.71 3.153A32.54 32.54 0 0 0 10.13 43z",
    fill: "#FF7058"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iv68db2gva"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h86v86H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaysafe);
export default __webpack_public_path__ + "static/media/playsafe.00e8f94b7f48159091aab2c8fff27417.svg";
export { ForwardRef as ReactComponent };